import { uiFactory } from './factories';
import { uiModule } from './implementations/core';
export { type ActivityThemeStyles, type LayoutSectionStyles } from 'shared/types/Theme';

export const { defaultActivityThemeStyles, assets, fonts, metadata, components } = uiFactory(uiModule);
